<template>
  <div class>
    <!--=== Header Start ===-->
    <div
      class="
        page-effect
        RegEvent-wrapper
        edu-rage
        event_list_reg
        ss-pre-ev-list
      "
    >
      <div class="expo-studio-container position-relative">
        <div
          class="
            d-md-flex
            justify-content-between
            align-items-start
            position-absolute
            studio-header
          "
        >
          <div class="studio-left">
            <h4>Booth Builder</h4>
            <h2 v-if="expoName">{{ expoName }}</h2>
            <h2 v-else>Your Booth Name</h2>
          </div>
          <div class="studio-right">
            <ul>
              <li>
                <a href="javascript:void(0)" @click="sendToExpoPreview()"
                  ><img src="../assets/Images/self-service/preview.svg"
                /></a>
                <p>Preview</p>
              </li>
              <!-- <li>
                <a href="javascript:void(0)"
                  ><img src="../assets/Images/self-service/notification.svg"
                /></a>
                <p>Notification</p>
              </li> -->
              <li>
                <a href="javascript:void(0)" @click="$router.push('/myprofile')"
                  ><img src="../assets/Images/self-service/my-profile.svg"
                /></a>
                <p>My Profile</p>
              </li>
              <li>
                <a href="javascript:void(0)" @click="sendToDefaultLanding()"
                  ><img src="../assets/Images/self-service/event-lobby.svg"
                /></a>
                <p>Exit Studio</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="studip-steps-bar">
          <ul>
            <li :class="e6 == 1 ? 'selected' : ' '">
              <div class="expo-option-list">
                <div class="expo-option-img">
                  <img src="../assets/Images/self-service/basic-info.svg" />
                </div>
                <div class="expo-option-details" @click="AddExpoBoothPopup(1)">
                  <p>Step 1</p>
                  <h5>Partner Information</h5>
                </div>
              </div>
            </li>
            <li :class="e6 == 2 ? 'selected' : ' '">
              <div class="expo-option-list">
                <div class="expo-option-img">
                  <img src="../assets/Images/self-service/resources-expo.svg" />
                </div>
                <div class="expo-option-details" @click="AddExpoBoothPopup(2)">
                  <p>Step 2</p>
                  <h5>Add / Select Point of Contact(s)</h5>
                </div>
              </div>
            </li>
            <li :class="e6 == 3 ? 'selected' : ' '">
              <div class="expo-option-list">
                <div class="expo-option-img">
                  <img src="../assets/Images/self-service/booth-graphics.svg" />
                </div>
                <div class="expo-option-details" @click="AddExpoBoothPopup(3)">
                  <p>Step 3</p>
                  <h5>Booth Graphics</h5>
                </div>
              </div>
            </li>

            <li :class="e6 == 4 ? 'selected' : ' '">
              <div class="expo-option-list">
                <div class="expo-option-img">
                  <img src="../assets/Images/self-service/social-links.svg" />
                </div>
                <div class="expo-option-details" @click="AddExpoBoothPopup(4)">
                  <p>Step 4</p>
                  <h5>Social Links</h5>
                </div>
              </div>
            </li>
            <li :class="e6 == 5 ? 'selected' : ' '">
              <div class="expo-option-list">
                <div class="expo-option-img">
                  <img src="../assets/Images/self-service/resources-expo.svg" />
                </div>
                <div class="expo-option-details" @click="AddExpoBoothPopup(5)">
                  <p>Step 5</p>
                  <h5>Resources / Video</h5>
                </div>
              </div>
            </li>
            <li :class="e6 == 6 ? 'selected' : ' '">
              <div class="expo-option-list">
                <div class="expo-option-img">
                  <img src="../assets/Images/self-service/resources-expo.svg" />
                </div>
                <div class="expo-option-details" @click="AddExpoBoothPopup(6)">
                  <p>Step 6</p>
                  <h5>Upcoming Events</h5>
                </div>
              </div>
            </li>
            <!-- <li :class="e6 == 5 ? 'selected' : ' '">
              <div class="expo-option-list">
                <div class="expo-option-img">
                  <img src="../assets/Images/self-service/booth-reps.svg" />
                </div>
                <div class="expo-option-details">
                  <p>Step 5</p>
                  <h5>Booth Reps.</h5>
                </div>
              </div>
            </li> -->
            <!-- <li :class="e6 == 6 ? 'selected' : ' '">
              <div class="expo-option-list">
                <div class="expo-option-img">
                  <img src="../assets/Images/self-service/adv-settings.svg" />
                </div>
                <div class="expo-option-details">
                  <p>Step 6</p>
                  <h5>Advance Settings</h5>
                </div>
              </div>
            </li> -->
          </ul>
        </div>
        <div class="studio-booth-wrapper">
          <div class="expobooth-blankimage position-relative">
            <div class="expo-default-img-wrap" v-if="!expoHotspotImg">
              <div class="white-transparent-booth">
                <img src="../assets/Images/blank-booth-white.png" />
              </div>
              <div class="white-outline-booth">
                <img src="../assets/Images/booth-outline-blue.png" />
              </div>
            </div>

            <div class="expo-default-img-wrap" v-else>
              <div class="">
                <img :src="expoHotspotImg" />
              </div>
            </div>

            <div class="add-booth-button" v-if="!expoName">
              <v-btn dark large color="#1a73e8" @click="AddExpoBoothPopup(1)">
                <img
                  src="../assets/Images/reg-ico/add-booth.svg"
                  class="mr-2"
                />
                Add New Booth</v-btn
              >
            </div>
            <!---after update image-->
            <div class="add-booth-button" v-else>
              <v-btn dark large color="#1a73e8" @click="openEditExpoPopup()">
                <img
                  src="../assets/Images/reg-ico/add-booth.svg"
                  class="mr-2"
                />
                Edit Booth</v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--add expo popup-->
    <v-dialog v-model="ExpoBoothAdd" max-width="950" scrollable>
      <v-card class="addboothModal expo-studio-popup">
        <v-card-title>
          <div class="add-ex-booth-modal-top">
            <h3 v-if="!toogleExpoHeadding">Add / Edit Exhibitor</h3>
            <h3 v-else>Update Exhibitor</h3>
            <div style="position: absolute; right: 15px; top: 15px">
              <v-icon style="z-index: 2" size="32" @click="ExpoBoothAdd = null"
                >close</v-icon
              >
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="cusom-wizard-wrap" v-if="cropImageUrl == null">
            <v-stepper v-model="e6" vertical>
              <div
                class="
                  d-flex
                  justify-content-start
                  align-items-start
                  d-mob-block
                "
              >
                <div
                  class="
                    d-md-flex
                    justify-content-start
                    align-items-start
                    flex-column
                    stepper-wrap
                  "
                >
                  <v-stepper-step :complete="e6 > 1" step="1" color="#000">
                    <p class="stepper-text mb-0" @click="AddExpoBoothPopup(1)">
                      <b>Partner Details</b>
                    </p>
                  </v-stepper-step>
                  <v-stepper-step :complete="e6 > 2" step="2" color="#000">
                    <p class="stepper-text mb-0" @click="AddExpoBoothPopup(2)">
                      <b> Add / Select Point of Contact(s)</b>
                    </p>
                  </v-stepper-step>
                  <v-stepper-step :complete="e6 > 3" step="3" color="#000">
                    <p class="stepper-text mb-0" @click="AddExpoBoothPopup(3)">
                      <b> Booth Graphic</b>
                    </p>
                  </v-stepper-step>
                  <v-stepper-step :complete="e6 > 4" step="4" color="#000">
                    <p class="stepper-text mb-0" @click="AddExpoBoothPopup(4)">
                      <b>Social Links</b>
                    </p>
                  </v-stepper-step>
                  <v-stepper-step :complete="e6 > 5" step="5" color="#000">
                    <p class="stepper-text mb-0" @click="AddExpoBoothPopup(5)">
                      <b>Resources/Video</b>
                    </p>
                  </v-stepper-step>
                  <v-stepper-step :complete="e6 > 6" step="6" color="#000">
                    <p class="stepper-text mb-0" @click="AddExpoBoothPopup(6)">
                      <b>Upcoming Events</b>
                    </p>
                  </v-stepper-step>
                  <!-- <v-stepper-step :complete="e6 > 6" step="6" color="#000">
                    <p class="stepper-text mb-0" @click="AddExpoBoothPopup(6)">
                      <b>Advanced (Optional)</b>
                    </p>
                  </v-stepper-step> -->
                  <v-stepper-step
                    :complete="e6 > 7"
                    step="7"
                    color="#000"
                    class="d-none"
                  >
                    <p class="stepper-text mb-0"><b>Booth Reps.</b></p>
                  </v-stepper-step>
                  <!--<v-stepper-step :complete="e6 > 6" step="6" color="#000">
                    <p class="stepper-text mb-0"><b>Advance Settings</b></p>
                  </v-stepper-step>-->
                </div>
                <div
                  class="
                    d-flex
                    justify-content-start
                    align-items-start
                    flex-column
                    stepper-content-wrap
                  "
                >
                  <v-stepper-content step="1" class="pt-0 mt-0 pl-2">
                    <div class="create-booth-form">
                      <div class="option-view">
                        <h4 class="pb-0 mb-0">Partner Details</h4>
                        <div class="option-pop-hld">
                          <v-icon size="25px" color="#333">
                            mdi-information-outline</v-icon
                          >
                          <div class="option-pop">
                            <img src="../assets/Images/basic-info.png" />
                          </div>
                        </div>
                      </div>

                      <p>
                        Add an expo booth to your event for attendees to engage
                        with at anytime. Please follow the below on-screen
                        instructions. Once the booth is setup, it will appear in
                        the expo area.
                      </p>
                      <div class="crete-booth-field">
                        <v-row class="my-0 mx-0">
                          <v-col cols="12" md="6" class="pl-0 mb-0">
                            <label>Partner Name*</label>
                            <input
                              type="text"
                              name="expoName"
                              id=""
                              v-model="expoName"
                            />
                            <label>Partner Phone No</label>
                            <input
                              type="text"
                              name=""
                              id=""
                              v-model="expoPhoneNo"
                            />
                            <!-- <label>Booth No</label>
                            <input
                              type="text"
                              name=""
                              id=""
                              v-model="expoBoothNo"
                            /> -->
                          </v-col>
                          <v-col cols="12" md="6" class="mb-0">
                            <div
                              :class="
                                expoLogo
                                  ? 'drag_n_drop px-2 no-expo-logo two-one-ratio-box'
                                  : 'drag_n_drop px-2 two-one-ratio-box'
                              "
                            >
                              <div
                                :class="
                                  expoLogo
                                    ? 'full-height expo-self-logo overflow-hidden'
                                    : 'full-width'
                                "
                              >
                                <img
                                  v-if="expoLogo"
                                  :src="expoLogo"
                                  alt="e2m"
                                />
                                <img
                                  v-else
                                  src="../assets/Images/reg-ico/img-icon.svg"
                                  class="mb-4"
                                />
                                <input
                                  type="file"
                                  name=""
                                  @change="update_exhibitorLogo"
                                  accept="image/*"
                                  id=""
                                />
                              </div>
                              <div :class="expoLogo ? 'expo-update' : 'mt-0'">
                                <h5 v-if="!expoLogo">
                                  Click to add partner logo
                                </h5>
                                <p v-if="!expoLogo">
                                  Logo should be in the ratio of 2:1 in
                                  transparent PNG format
                                  <br>
                                  Maximum file size: Up to 10 MB
                                </p>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="mb-0 pl-0">
                            <label
                              >Partner Email
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    color="#b4b4b4"
                                    size="20px"
                                    v-bind="attrs"
                                    v-on="on"
                                    >mdi-information-outline</v-icon
                                  >
                                </template>
                                <span>Email</span>
                              </v-tooltip>
                            </label>
                            <input
                              type="email"
                              name=""
                              id=""
                              v-model="expoEmail"
                            />
                          </v-col>
                          <v-col cols="12" md="6" class="mb-0">
                            <label>Partner Website</label>
                            <input
                              type="url"
                              name=""
                              id=""
                              v-model="expoWebsite"
                            />
                          </v-col>
                          <v-col cols="12" md="12" class="mb-0 pl-0">
                            <label class="d-flex"
                              >Showcase Video Link(Youtube or Vimeo)
                              <div class="video-link-tooltip">
                                <v-icon color="#b4b4b4" size="20px"
                                  >mdi-information-outline</v-icon
                                >
                                <div class="video-link-hld">
                                  <img
                                    src="../assets/Images/landing/video-link-img.png"
                                  />
                                </div>
                              </div>
                              <!-- <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  
                                </template>
                                <span> Video Link</span>
                              </v-tooltip> -->
                            </label>
                            <input
                              type="url"
                              name=""
                              id=""
                              v-model="expoShowcaseVideo"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <v-row class="mt-0">
                        <v-col md="12" sm="12" cols="12">
                          <div class="hotspot-category">
                            <label>Company description</label>
                            <textarea
                              cols="12"
                              rows="12"
                              v-model="expoProfile"
                            ></textarea>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-stepper-content>
                  <v-stepper-content step="2" class="pt-0 mt-0 pl-2">
                    <div class="option-view">
                      <h4 class="pb-0 mb-0">
                        Add / Select Point of Contact(s)
                      </h4>
                      <div class="option-pop-hld">
                        <v-icon size="25px" color="#333">
                          mdi-information-outline</v-icon
                        >
                        <div class="option-pop">
                          <img src="../assets/Images/point-of-contacts.png" />
                        </div>
                      </div>
                    </div>
                    <v-row>
                      <v-col md="5" sm="5" cols="12" class="mt-4">
                        <div class="rep-add-details">
                          <label>Point of Contact Name</label>
                          <input type="text" name="repName" v-model="repName" />
                        </div>
                      </v-col>
                      <v-col md="5" sm="5" cols="12" class="mt-4">
                        <div class="rep-add-details">
                          <label>Email</label>
                          <input
                            type="email"
                            name="repEmail"
                            v-model="repEmail"
                          />
                        </div>
                      </v-col>
                      <v-col md="2" sm="2" cols="12" class="mt-4">
                        <v-btn
                          class="add-btn"
                          dark
                          color="#0d6fec"
                          width="100%"
                          @click="addRepresentatives()"
                          >Add</v-btn
                        >
                      </v-col>
                      <v-col md="12" sm="12" cols="12">
                        <div class="hotspot-category">
                          <!-- <label>Select Booth Reps</label> -->
                          <label
                            >Select Booth Point of Contact(s)
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="#b4b4b4"
                                  size="20px"
                                  v-bind="attrs"
                                  v-on="on"
                                  >mdi-information-outline</v-icon
                                >
                              </template>
                              <span
                                >Booth Point of Contact can upload content for
                                booth creation, graphics and engage with
                                attendees during live event
                              </span>
                            </v-tooltip>
                          </label>
                          <!-- <v-autocomplete
                              outlined
                              color="#000"
                              min-height="50px"
                              v-model="expoMappedContact"
                              :items="mappedContactsList"
                              item-text="Name"
                              item-value="AttendeeId"
                              multiple
                              return-object
                              chips
                              small-chips
                          >
                          </v-autocomplete>  -->

                          <v-autocomplete
                            :items="mappedContactsList"
                            color="#000"
                            min-height="50px"
                            filled
                            chips
                            item-text="Name"
                            item-value="AttendeeId"
                            multiple
                            v-model="selectedboothReps"
                          >
                            <template v-slot:selection="data">
                              <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="removeSelectedReps(data.item)"
                              >
                                <v-avatar left>
                                  <v-img
                                    :src="data.item.ProfilePictureURL"
                                  ></v-img>
                                </v-avatar>
                                {{ data.item.Name }}
                              </v-chip>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-avatar>
                                  <img :src="data.item.ProfilePictureURL" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title
                                    v-html="data.item.Name"
                                  ></v-list-item-title>
                                  <v-list-item-subtitle
                                    v-html="data.item.Company"
                                  ></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>

                            <!-- <template v-slot:item="data">
                              <template>
                                <v-list-item-content
                                  v-text="data.item"
                                ></v-list-item-content>
                              </template>
                            </template> -->
                          </v-autocomplete>
                        </div>
                      </v-col>
                      <v-col md="12" sm="12" cols="12">
                        <div class="hotspot-category">
                          <!-- <label>Select Booth Admin</lFabel> -->
                          <label
                            >Select Booth Admin
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="#b4b4b4"
                                  size="20px"
                                  v-bind="attrs"
                                  v-on="on"
                                  >mdi-information-outline</v-icon
                                >
                              </template>
                              <span
                                >Booth Admin can add / remove Booth Point of
                                Contacts
                              </span>
                            </v-tooltip>
                          </label>
                          <!-- <v-autocomplete
                              outlined
                              color="#000"
                              min-height="50px"
                              v-model="expoMappedContact"
                              :items="mappedContactsList"
                              item-text="Name"
                              item-value="AttendeeId"
                              multiple
                              return-object
                              chips
                              small-chips
                          >
                          </v-autocomplete>  -->

                          <v-autocomplete
                            :items="mappedContactsAdminList"
                            color="#000"
                            min-height="50px"
                            filled
                            chips
                            item-text="Name"
                            item-value="AttendeeId"
                            multiple
                            v-model="selectedboothAdmin"
                          >
                            <template v-slot:selection="data">
                              <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="removeSelectedAdmins(data.item)"
                              >
                                <v-avatar left>
                                  <v-img
                                    :src="data.item.ProfilePictureURL"
                                  ></v-img>
                                </v-avatar>
                                {{ data.item.Name }}
                              </v-chip>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-avatar>
                                  <img :src="data.item.ProfilePictureURL" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title
                                    v-html="data.item.Name"
                                  ></v-list-item-title>
                                  <v-list-item-subtitle
                                    v-html="data.item.Company"
                                  ></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>

                            <!-- <template v-slot:item="data">
                              <template>
                                <v-list-item-content
                                  v-text="data.item"
                                ></v-list-item-content>
                              </template>
                            </template> -->
                          </v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                  <v-stepper-content step="3" class="pt-0 mt-0 pl-2">
                    <div class="create-booth-form">
                      <div class="option-view">
                        <h4 class="pb-0 mb-0">Booth Graphic</h4>
                        <div class="option-pop-hld">
                          <v-icon size="25px" color="#333">
                            mdi-information-outline</v-icon
                          >
                          <div class="option-pop">
                            <img src="../assets/Images/booth-graphic.png" />
                          </div>
                        </div>
                      </div>
                      <p>
                        Add an expo booth to your event for attendees to engage
                        with at anytime. Please follow the below on-screen
                        instructions. Once the booth is setup, it will appear in
                        the expo area.
                      </p>

                      <v-row class="my-0">
                        <v-col cols="12" md="12">
                          <div
                            class="
                              hotspot-category
                              d-flex
                              justify-content-between
                              align-items-center
                            "
                          >
                            <div>
                              <label class="label-serial position-relative"
                                >Select a Category of booth*</label
                              >
                              <div
                                :class="isDefaultTemplateSelected ? 'disable-drop position-relative select-box-cat-wrap' : 'position-relative select-box-cat-wrap'"
                              >
                                <v-select
                                  :readonly="isDefaultTemplateSelected"
                                  outlined
                                  color="#000"
                                  height="50px"
                                  v-model="expoCategory"
                                  :items="ExpoCategoryList"
                                  item-text="Name"
                                  v-on:change="onCategoryUpdate(expoCategory)"
                                  return-object
                                ></v-select>
                              </div>
                            </div>
                            <!-- <div class="link-section-wrap">
                              <a
                                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FExhibitor%20Booth%20Design%20Templates.pdf?alt=media&token=8b69fa44-36ff-4b0a-8f22-fdd5c8147f4c"
                                target="_blank"
                                >Available Design Options
                                <span
                                  ><v-icon size="24" color="#333"
                                    >mdi-open-in-new</v-icon
                                  ></span
                                ></a
                              >
                            </div> -->
                          </div>
                        </v-col>
                        <v-col cols="12" md="12">
                          <div class="event-booth-hotspot-image-wrap">
                            <img :src="previewCategoryImage" />
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-stepper-content>
                  <!--step 3-->
                  <v-stepper-content step="4" class="full-width pt-0 mt-0 pl-2">
                    <div class="create-booth-form">
                      <div class="option-view">
                        <h4 class="pb-0 mb-0">Social Link</h4>
                        <div class="option-pop-hld">
                          <v-icon size="25px" color="#333">
                            mdi-information-outline</v-icon
                          >
                          <div class="option-pop">
                            <img src="../assets/Images/social-links.png" />
                          </div>
                        </div>
                      </div>
                      <div class="form-row align-items-center">
                        <div class="col-md-12">
                          <!--repeat box start-->
                          <div class="Social-Link-wrap">
                            <span
                              class="social-close d-block text-right"
                              @click="expoFacebook = ''"
                            >
                              <img
                                src="../assets/Images/icons/close.svg"
                                class="mr-1"
                                width="25px"
                              />
                            </span>
                            <v-icon color="#000" size="18px" class="mr-1"
                              >mdi-drag</v-icon
                            >
                            <label class="" for="inlineFormInputGroup">
                              <img
                                src="../assets/Images/self-service/facebook.png"
                                class="mr-1"
                                width="25px"
                              />
                              Facebook</label
                            >
                            <div class="input-group mb-2">
                              <div class="input-group-prepend">
                                <div class="input-group-text">URL</div>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                name=""
                                id=""
                                v-model="expoFacebook"
                              />
                            </div>
                          </div>
                          <!--repeat box end-->
                          <!--repeat box start-->
                          <div class="Social-Link-wrap">
                            <span
                              class="social-close d-block text-right"
                              @click="expoTwitter = ''"
                            >
                              <img
                                src="../assets/Images/icons/close.svg"
                                class="mr-1"
                                width="25px"
                              />
                            </span>
                            <v-icon color="#000" size="18px" class="mr-1"
                              >mdi-drag</v-icon
                            >
                            <label class="" for="inlineFormInputGroup">
                              <img
                                src="../assets/Images/self-service/twitter.png"
                                class="mr-1"
                                width="25px"
                              />
                              Twitter</label
                            >
                            <div class="input-group mb-2">
                              <div class="input-group-prepend">
                                <div class="input-group-text">URL</div>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                name=""
                                id=""
                                v-model="expoTwitter"
                              />
                            </div>
                          </div>
                          <!--repeat box end-->
                          <!--repeat box start-->
                          <div class="Social-Link-wrap">
                            <span
                              class="social-close d-block text-right"
                              @click="expoLinkdin = ''"
                            >
                              <img
                                src="../assets/Images/icons/close.svg"
                                class="mr-1"
                                width="25px"
                              />
                            </span>
                            <v-icon color="#000" size="18px" class="mr-1"
                              >mdi-drag</v-icon
                            >
                            <label class="" for="inlineFormInputGroup">
                              <img
                                src="../assets/Images/self-service/linkdin.png"
                                class="mr-1"
                                width="25px"
                              />
                              Linkdin</label
                            >
                            <div class="input-group mb-2">
                              <div class="input-group-prepend">
                                <div class="input-group-text">URL</div>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                iname=""
                                id=""
                                v-model="expoLinkdin"
                              />
                            </div>
                          </div>
                          <!--repeat box end-->
                           <!--repeat box start-->
                          <div class="Social-Link-wrap">
                            <span
                              class="social-close d-block text-right"
                              @click="expoinstagram = ''"
                            >
                              <img
                                src="../assets/Images/icons/close.svg"
                                class="mr-1"
                                width="25px"
                              />
                            </span>
                            <v-icon color="#000" size="18px" class="mr-1"
                              >mdi-drag</v-icon
                            >
                            <label class="" for="inlineFormInputGroup">
                              <img
                                src="../assets/Images/self-service/instagram.png"
                                class="mr-1"
                                width="25px"
                              />
                              instagram</label
                            >
                            <div class="input-group mb-2">
                              <div class="input-group-prepend">
                                <div class="input-group-text">URL</div>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                iname=""
                                id=""
                                v-model="expoinstagram"
                              />
                            </div>
                          </div>
                          <!--repeat box end-->
                          <div class="add_more_link d-none">
                            <label class="">Add More</label>
                            <ul class="p-0 m-0">
                              <li>
                                <img
                                  src="../assets/Images/self-service/linkedin.png"
                                />
                              </li>

                              <li>
                                <img
                                  src="../assets/Images/self-service/youtube.png"
                                />
                              </li>
                              <li>
                                <img
                                  src="../assets/Images/self-service/linkedin.png"
                                />
                              </li>

                              <li>
                                <img
                                  src="../assets/Images/self-service/youtube.png"
                                />
                              </li>
                              <li>
                                <img
                                  src="../assets/Images/self-service/instagram.png"
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-stepper-content>
                  <!--3 end---->
                  <!--step 4 start-->
                  <v-stepper-content
                    step="5"
                    class="step-content full-width pt-0 mt-0"
                  >
                    <div class="create-booth-form">
                      <div class="option-view">
                        <h4 class="pb-0 mb-0">Resources/Video</h4>
                        <div class="option-pop-hld">
                          <v-icon size="25px" color="#333">
                            mdi-information-outline</v-icon
                          >
                          <div class="option-pop">
                            <img src="../assets/Images/image_2022_04_20T11_25_36_939Z.png" />
                          </div>
                        </div>
                      </div>

                      <div class="upload-resources-hld">
                        <div class="file-drop-hld resource-expo">
                          <label class="upload-butn">
                            <input
                              type="File"
                              name=""
                              id=""
                              value=""
                              accept=".csv, .excel,.xlsx,.pdf,.doc,.docx"
                              @change="
                                UploadExpoResource(
                                  $event,
                                  'ExpoResource',
                                  'ExpoResource'
                                )
                              "
                            />
                            Upload Resources
                          </label>
                        </div>
                        <div class="oroption"><span>Or</span></div>
                        <!---->
                        <div class="row crete-booth-field">
                          <div class="col-5">
                            <label>Title</label>
                            <input
                              type="text"
                              name="exhibitorResourceTitle"
                              id=""
                              v-model="exhibitorResourceTitle"
                            />
                          </div>
                          <div class="col">
                            <label>Link</label>
                            <input
                              type="text"
                              name="exhibitorResourceLink"
                              id=""
                              v-model="exhibitorResourceLink"
                            />
                          </div>
                          <div class="col-3">
                            <label class="py-2 mb-1"> &nbsp; </label>
                            <v-btn
                              class="resource-videoadd-btn"
                              large
                              dark
                              color="#1973e7"
                              width="100%"
                              height="50px"
                              @click="add_expo_link()"
                              >Add</v-btn
                            >
                          </div>
                        </div>
                        <!---->

                        <div class="resources-file-hld mt-3">
                          <div
                            class="single-file-resource mb-3 position-relative"
                            v-for="resource in ResourcesForView"
                            v-bind:key="resource"
                          >
                            <div class="file-resource-left">
                              <div class="file-ico-img">
                                <img
                                  v-if="resource.Url.includes('.pdf')"
                                  src="../assets/Images/icons/pdf-class.svg"
                                />
                                <img
                                  v-else-if="resource.Url.includes('.mp4')"
                                  src="../assets/Images/icons/video-icon.svg"
                                />
                              </div>
                              <div class="file-name-details">
                                <a :href="resource.Url" target="_blank">
                                  <p>
                                    {{ resource.Filename }}
                                  </p>
                                </a>
                              </div>
                            </div>
                            <div class="drag-ico">
                              <v-icon size="25px" color="#333"
                                >mdi-drag-vertical</v-icon
                              >
                            </div>
                            <!-- <v-btn icon
                              ><v-icon color="#333" size="25px"
                                >mdi-trash-can-outline</v-icon
                              ></v-btn
                            > -->
                          </div>
                          

                          <div v-if="ResourcesLink && ResourcesLink.length > 0">
                            <div
                              class="
                                single-file-resource
                                mb-3
                                position-relative
                              "
                              v-for="link in ResourcesLink"
                              v-bind:key="link.Id"
                            >
                              <div class="file-resource-left">
                                <div class="file-ico-img">
                                  <img src="../assets/Images/icons/link.svg" />
                                </div>
                                <div class="file-name-details">
                                  <a :href="link.Link" target="_blank">
                                    <p>
                                      {{ link.Title }}
                                    </p>
                                  </a>
                                </div>
                              </div>
                              <div class="drag-ico">
                                <v-icon size="25px" color="#333"
                                  >mdi-drag-vertical</v-icon
                                >
                              </div>
                              <!-- <v-btn icon
                                ><v-icon color="#333" size="25px"
                                  >mdi-trash-can-outline</v-icon
                                ></v-btn
                              > -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-stepper-content>
                  <v-stepper-content
                    step="6"
                    class="step-content full-width pt-0 mt-0"
                  >
                    <div class="create-booth-form">
                      <div class="option-view">
                        <h4 class="pb-0 mb-0">
                          Featured Events and Programmes
                        </h4>
                        <div class="option-pop-hld">
                          <v-icon size="25px" color="#333">
                            mdi-information-outline</v-icon
                          >
                          <div class="option-pop2">
                            <img src="../assets/Images/info.jpg" />
                          </div>
                        </div>
                      </div>
                      <v-row>
                        <v-col md="6" sm="6" cols="12">
                          <div class="info-wrap-event-hld mt-3">
                            <label>Name of Event/Programme</label>
                            <input type="text" v-model="podiumTitle" />
                          </div>
                        </v-col>
                        <!-- <v-col md="6" sm="6" cols="12">
                          <div class="info-wrap-event-hld mt-3">
                            <label>CTA Link</label>
                            <input type="text" v-model="ctaLink" />
                          </div>
                        </v-col> -->
                        <v-col md="6" sm="6" cols="12">
                          <div class="info-wrap-event-hld mt-3">
                            <label>Event Website</label>
                            <input type="text" v-model="knowMoreLink" />
                          </div>
                        </v-col>
                        <v-col md="12" sm="12" cols="12">
                          <div class="info-box info-wrap-event-hld">
                            <label>Event Description</label>

                            <textarea
                              cols="12"
                              rows="20"
                              v-model="podiumDescription"
                              @keyup="remaincharCount()"
                              :class="
                                countExpo == 0
                                  ? 'border-danger text-danger'
                                  : ''
                              "
                            ></textarea>
                            <br />
                            <span
                              :class="countExpo == 0 ? 'text-danger' : ''"
                              >{{ remaincharactersText }}</span
                            >
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-stepper-content>
                  <!--step 4 end-->
                  <!--step 5 start-->
                  <!-- <v-stepper-content
                    step="6"
                    class="full-width representative-step pt-0 mt-0 d-none"
                  >
                    <div class="create-booth-form">
                      <h4 class="pb-2">Representative</h4>
                  
                      <div class="from-group mb-3">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Add Contact"
                          name=""
                          id=""
                          v-model="expoRepresentative"
                        />
                      </div>
                      <div
                        class="
                          row
                          representative-list-box
                          m-0
                          align-items-center
                        "
                      >
                        <div class="col-md-4 align-items-center d-flex">
                          <span class="circle-sm"
                            ><img
                              src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1623256581214E1644001910926%2FAttendees%2F99925587_1644337554823_Mc%20Marshall%20Headshot%20Now.JPG?alt=media&token=af2008a6-030a-464f-ba05-bec5d2df5896"
                            />
                          </span>
                          <h6 class="m-0 pl-3">Marshall Chiles</h6>
                        </div>
                        <div class="col-md-8">
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            marshall@standupsocials.com
                            <span class="text-right">
                              <img
                                src="../assets/Images/icons/close.svg"
                                class="mr-1"
                                width="10px"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                 
                    </div>
                  </v-stepper-content> -->
                  <!--step 5 End-->
                  <!--step 5 start-->
                  <!-- <v-stepper-content
                    step="7"
                    class="full-width representative-step pt-0 mt-0"
                  >
                    <v-row class="my-0 pt-0">
                      <v-col cols="12" md="12" class="mt-0 pt-0">
                        <label class="label-serial2 position-relative"
                          >Download the related Design file in PSD to
                          edit</label
                        >
                        <div class="download-psd">
                          <button @click="downloadPSD()">
                            <img src="../assets/Images/psd-ico.png" />
                            Download PSD
                          </button>
                        </div>
                      </v-col>
                      <v-col cols="12" md="12" class="mt-0 pt-0">
                        <div class="hotspot-image-upload mt-3">
                          <label class="label-serial3 position-relative"
                            >Upload JPG/PNG after editing
                            <v-icon color="#b4b4b4" size="20px"
                              >mdi-information-outline</v-icon
                            ></label
                          >
                          <div
                            class="
                              d-flex
                              justify-content-start
                              align-items-center
                              upload-hotspot-img-box-wrap
                            "
                          >
                            <input
                              type="text"
                              name=""
                              id=""
                              v-model="expoHotspotImg"
                              class="mr-2"
                              placeholder="Upload the booth image after editing here"
                            />

                            <label class="upload-butn">
                              <input
                                type="File"
                                name=""
                                id=""
                                value=""
                                @change="
                                  UploadImage(
                                    $event,
                                    'HotspotImageURL',
                                    'HotspotImageURL'
                                  )
                                "
                                accept="image/*"
                              />
                              Upload
                            </label>
                          </div>
                        </div>
                      </v-col>

                      <v-col col="12" md="12" sm="12">
                        <div class="preview-booth-hld"></div>
                      </v-col>

                      <hr />
                    </v-row>
                  </v-stepper-content> -->
                  <!--step 5 End-->
                </div>
              </div>
            </v-stepper>
          </div>
          <div class="ss-cns-body-wrap" v-else>
            <h5 class="my-4">
              <strong class="d-flex"
                ><v-icon
                  @click="cropImageUrl = null"
                  size="30"
                  color="black"
                  class="mr-2 cursor-pointer"
                  >mdi-arrow-left</v-icon
                >Aspect Ratio for this image is {{ displayImageRatio }}. To crop
                this image, simply drag and click Upload.<br/>Please zoom in/out with CTRL +/- for selecting the image</strong
              >
            </h5>

            <cropper
              :key="resetCropper"
              v-bind:aspectValue="imageRatio"
              :sourceImage="cropImageUrl"
              :file="imageFileDetails"
              :uploadPath="folderImageUploadPath"
              :clientId="clientId"
              :eventId="eventId"
              @uploadedImagePath="uploadedImagePath"
            />
          </div>
        </v-card-text>
        <v-divider class="m-0" v-if="cropImageUrl == null"></v-divider>
        <v-card-actions v-if="cropImageUrl == null">
          <div
            class="
              d-flex
              my-5
              full-width
              align-items-end
              justify-content-end
              bhld
            "
          >
            <v-btn
              class="mr-2 cancel-standard"
              outlined
              large
              color="#959595"
              width="122px"
              @click="ExpoBoothAdd = false"
              >Cancel</v-btn
            >

            <v-btn
              class="mr-2 save-standard"
              outlined
              large
              color="#959595"
              width="122px"
              v-if="e6 > 1"
              @click="expoFormBackStep()"
              >Previous</v-btn
            >
            <v-btn
             class="save-standard"
              v-if="expoName && e6 <= 5"
              large
              dark
              color="#1973e7"
              @click="expoFormSubmit()"
              width="122px"
              >Save & Next</v-btn
            >

            <v-btn
              v-if="expoName && e6 == 6 && countExpo != 0"
              large
              dark
              color="#1973e7"
              @click="expoFormSubmit()"
              width="122px"
              :disabled="countExpo == 0 ? true : false"
              >Save & Exit</v-btn
            >

            <v-btn
              v-if="expoName && e6 == 6 && countExpo == 0"
              large
              color="#1973e7"
              width="122px"
              disabled
              >Save & Exit</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--add expo end-->
  </div>
</template>
<script>
// import jQuery from "jquery";
// let $ = jQuery;
var self;
import Vue from "vue";
import Cropper from "../components/CropperComponent.vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import APIs from "@/components/APIInit";
import { bus } from "@/main";
import router from "../router";
import store from "../store";
Vue.use(VueMoment, {
  moment,
});

const splitName = (name = "") => {
  const [firstName, ...lastName] = name.split(" ").filter(Boolean);
  return {
    firstName: firstName,
    lastName: lastName.join(" "),
  };
};

const mergeArrays = (arr1 = [], arr2 = []) => {
  let res = [];
  res = arr1.map((obj) => {
    const index = arr2.findIndex((el) => el["AttendeeId"] == obj["AttendeeId"]);
    const {
      AttendeeId,
      Company,
      Designation,
      Email,
      FirstName,
      LastName,
      ProfilePictureURL,
      Name,
    } = index !== -1 ? arr2[index] : {};
    return {
      ...obj,
      AttendeeId,
      Company,
      Designation,
      Email,
      FirstName,
      LastName,
      ProfilePictureURL,
      Name,
    };
  });
  return res;
};

export default {
  data() {
    return {
      previousMappedContactsCount: 0,
      maxcharacter: 290,
      remaincharactersText: "Remaining 290 characters.",
      countExpo: null,
      isDefaultTemplateSelected: false,
      additionalHtml: null,
      podiumTitle: null,
      ctaLink: null,
      knowMoreLink: null,
      podiumDescription: null,
      selectedboothReps: [],
      selectedboothAdmin: [],
      repName: null,
      repEmail: null,
      expoCategoryPSDPath: null,
      Resources: [],
      ResourcesLink: [],
      ResourcesForView: [],
      exhibitorResourceTitle: null,
      exhibitorResourceLink: null,
      mappedContactsList: [],
      mappedContactsAdminList: [],
      ExpoCategoryList: [],
      imageRatio: 2 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "2:1",
      popupCropper: false,
      IsSubmitting: false,
      uploadedFile: null,
      imageFileDetails: null,
      folderImageUploadPath: null,
      clientId: "",
      eventId: "",
      //expo form
      ExpoBoothAdd: false,
      e6: 1,
      expoName: "",
      expoPhoneNo: "",
      expoBoothNo: "",
      expoEmail: "",
      expoWebsite: "",
      expoCategory: "",
      expoMappedContact: [],
      expoProfile: "",
      expoShowcaseVideo: "",
      expoHotspotImg: "",
      expoId: "",
      expoFacebook: "",
      expoTwitter: "",
      expoLinkdin: "",
      expoinstagram:"",
      expoRepresentative: "",
      expoLogo: "",
      toogleExpoHeadding: false,
      previewCategoryImage: null,
      autoUpdate: true,
      friends: ["Sandra Adams", "Britta Holt"],
      isUpdating: false,
      people: [
        { header: "Group 1" },
        {
          name: "Sandra Adams",
          group: "Group 1",
          avatar:
            "https://static.toiimg.com/thumb/resizemode-4,msid-76729750,imgsize-249247,width-720/76729750.jpg",
        },
        {
          name: "Ali Connors",
          group: "Group 1",
          avatar:
            "https://static.toiimg.com/thumb/resizemode-4,msid-76729750,imgsize-249247,width-720/76729750.jpg",
        },
        {
          name: "Trevor Hansen",
          group: "Group 1",
          avatar:
            "https://static.toiimg.com/thumb/resizemode-4,msid-76729750,imgsize-249247,width-720/76729750.jpg",
        },
        {
          name: "Tucker Smith",
          group: "Group 1",
          avatar:
            "https://static.toiimg.com/thumb/resizemode-4,msid-76729750,imgsize-249247,width-720/76729750.jpg",
        },
        { divider: true },
        { header: "Group 2" },
        {
          name: "Britta Holt",
          group: "Group 2",
          avatar:
            "https://static.toiimg.com/thumb/resizemode-4,msid-76729750,imgsize-249247,width-720/76729750.jpg",
        },
        {
          name: "Jane Smith ",
          group: "Group 2",
          avatar:
            "https://static.toiimg.com/thumb/resizemode-4,msid-76729750,imgsize-249247,width-720/76729750.jpg",
        },
        {
          name: "John Smith",
          group: "Group 2",
          avatar:
            "https://static.toiimg.com/thumb/resizemode-4,msid-76729750,imgsize-249247,width-720/76729750.jpg",
        },
        {
          name: "Sandra Williams",
          group: "Group 2",
          avatar:
            "https://static.toiimg.com/thumb/resizemode-4,msid-76729750,imgsize-249247,width-720/76729750.jpg",
        },
      ],
    };
  },
  computed: {},
  components: {
    Cropper,
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
  },
  created() {
    self = this;
  },
  mounted() {
    this.clientId = this.$store.state.client[0].id;
    this.eventId = this.$store.state.eventid;
    if (this.$route.params.exhibitorid) {
      this.fetchExhibiorDetailsbyID(this.$route.params.exhibitorid);
    }
    //this.FetchAttendees();
    this.FetchCategoryList();
  },
  methods: {
    remaincharCount: function () {
      if (this.podiumDescription.length > this.maxcharacter) {
        this.remaincharactersText =
          "Exceeded " + this.maxcharacter + " characters limit.";
      } else {
        var remainCharacters =
          this.maxcharacter - this.podiumDescription.length;
        this.countExpo = remainCharacters;
        this.remaincharactersText =
          "Remaining " + remainCharacters + " characters.";
      }
    },
    sendBulkAdminInviteMail() {
      console.log("mail>>>>>>", self.invitedAttendees);

      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      var requestData = {};
      if (self.selectedboothAdmin && self.selectedboothAdmin.length > 0) {
        requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.$store.state.client[0].id,
            eventId: self.$store.state.eventid,
            recipientType: "Exhibitor",
            templatePath: "/mailtpl/Exhibitor/Reminder",
          },
          data: self.selectedboothAdmin,
        };
      }

      // if (self.selectedboothReps.length > 0) {
      //   requestData = {
      //     key: {
      //       instanceId: "OA_UAT",
      //       clientId: self.$store.state.client[0].id,
      //       eventId: self.$store.state.eventid,
      //       recipientType: "ExhibitorREP",
      //       templatePath: "/mailtpl/Exhibitor/RepReminder",
      //     },
      //     data: tempBoothReps,
      //   };
      // }

      axios
        .post(APIs.SendInviteeBulkMail, requestData, { headers: headers })
        .then(function (res) {
          if (res.data.status == 0) {
            console.log("res-----", res);
          }
        })
        .catch(() => {
          console.log("error");
        });
    },
    sendBulkRepInviteMail() {
      console.log("mail>>>>>>", self.invitedAttendees);
      var tempBoothReps = self.selectedboothReps;

      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      var requestData = {};
      if (self.selectedboothAdmin && self.selectedboothAdmin.length > 0) {
        self.selectedboothAdmin.map((admin) => {
          if (self.selectedboothReps.includes(admin)) {
            // dont send mail
            tempBoothReps = tempBoothReps.filter(function (item) {
              return item !== admin;
            });
          }
          //self.expoMappedContact.push(user);
        });

        // requestData = {
        //   key: {
        //     instanceId: "OA_UAT",
        //     clientId: self.$store.state.client[0].id,
        //     eventId: self.$store.state.eventid,
        //     recipientType: "Exhibitor",
        //     templatePath: "/mailtpl/Exhibitor/Reminder",
        //   },
        //   data: self.selectedboothAdmin,
        // };
      }

      if (tempBoothReps && tempBoothReps.length > 0) {
        requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.$store.state.client[0].id,
            eventId: self.$store.state.eventid,
            recipientType: "ExhibitorREP",
            templatePath: "/mailtpl/Exhibitor/RepReminder",
          },
          data: tempBoothReps,
        };
      }

      axios
        .post(APIs.SendInviteeBulkMail, requestData, { headers: headers })
        .then(function (res) {
          if (res.data.status == 0) {
            console.log("res-----", res);
          }
        })
        .catch(() => {
          console.log("error");
        });
    },
    removeSelectedReps(item) {
      const index = this.selectedboothReps.indexOf(item.AttendeeId);
      if (index >= 0) this.selectedboothReps.splice(index, 1);
    },
    removeSelectedAdmins(item) {
      const index = this.selectedboothAdmin.indexOf(item.AttendeeId);
      if (index >= 0) this.selectedboothAdmin.splice(index, 1);
    },
    addRepresentatives() {
      var splittedName = splitName(self.repName);
      console.log("splittedName=====", splittedName);
      bus.$emit("toggleLoader", true);

      var repersentatives = {};

      var postData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.getClientId(),
          eventId: self.getEventId(),
        },
        data: {
          Email: self.repEmail.toLowerCase().trim(),
        },
      };

      let headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.XAPIkey,
      };
      axios
        .post(APIs.CheckUserStatus, JSON.stringify(postData), {
          headers: headers,
        })
        .then((response) => {
          if (response.data.attendeeStatus) {
            repersentatives = {
              AttendeeId: response.data.result.UserId,
              Company: response.data.result.Company,
              Designation: response.data.result.Designation,
              Email: response.data.result.Email,
              FirstName: response.data.result.FirstName,
              LastName: response.data.result.LastName,
              ProfilePictureURL: response.data.result.ProfilePictureURL,
              Name: response.data.result.Name,
            };
            var userExists = this.mappedContactsList.some(
              (user) => user.Email === self.repEmail
            );

            if (!userExists) {
              this.mappedContactsList.push(repersentatives);
              this.selectedboothReps.push(response.data.result.UserId);
              this.selectedboothAdmin.push(response.data.result.UserId);
              this.mappedContactsAdminList.push(repersentatives);
              self.repName = null;
              self.repEmail = null;
            } else {
              self.repName = null;
              self.repEmail = null;
            }

            bus.$emit("toggleLoader", false);
          } else {
            // bus.$emit("toggleLoader", false);
            console.log("email not exist");

            var attendee = {
              Name: self.repName.trim(),
              FirstName: splittedName.firstName.trim(),
              LastName: splittedName.lastName.trim(),
              Email: self.repEmail.toLowerCase().trim(),
              AttendeeId: null,
              Phone: "",
              Country: "",
              FormType: "FREE",
              RegistrationType: {
                ColorCode: "",
                RegistrationType: "Attendee",
                RegistrationTypeId: "",
              },
              Company: "",
              Designation: "",
              Profile: "",
              ProfilePictureURL: "",
              Website: "",
              SocialLinks: [
                { Facebook: "" },
                { GooglePlus: "" },
                { LinkedIn: "" },
                { Twitter: "" },
              ],
              Tags: "",
              MailSent: false,
              IsVerified: true,
              IsPublished: true,
              UserRoles: [
                {
                  RoleID: 10,
                  RoleName: "AppUser",
                },
              ],
            };
            let headers = {
              "Content-Type": "application/json",
              "x-api-key": APIs.DeleteAttendeeApiKey,
            };
            let requestData = {
              key: {
                instanceId: "OA_UAT",
                clientId: self.getClientId(),
                eventId: self.getEventId(),
              },
              data: attendee,
              sendMail: 0,
            };
            axios
              .post(APIs.AddSingleAttendee, requestData, {
                headers: headers,
              })
              .then(function (res) {
                bus.$emit("toggleLoader", false);
                debugger;
                if (res.status == 200) {
                  console.log("res=====", res.data.regStatus);
                  if (res.data.regStatus == 0) {
                    repersentatives = {
                      AttendeeId: res.data.data.UserId,
                      Company: "",
                      Designation: "",
                      Email: res.data.data.Email,
                      FirstName: res.data.data.FirstName,
                      LastName: res.data.data.LastName,
                      ProfilePictureURL: "",
                      Name: res.data.data.Name,
                    };
                    console.log("repersentatives=====", repersentatives);

                    self.mappedContactsList.push(repersentatives);
                    self.selectedboothReps.push(res.data.data.UserId);
                    self.selectedboothAdmin.push(res.data.data.UserId);
                    self.mappedContactsAdminList.push(repersentatives);

                    self.repName = null;
                    self.repEmail = null;
                  }
                } else {
                  self.showSnackbar("Something went wrong", "error", "top");
                }
              })
              .catch(function (error) {
                bus.$emit("toggleLoader", false);
                console.log("Error adding attendee:", error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
          bus.$emit("toggleLoader", false);
        });

      // var repersentatives = {
      //   Name: self.repName,
      //   Email: self.repEmail,
      //   FirstName: splittedName.firstName,
      //   LastName: splittedName.lastName
      // }
    },
    remove(item) {
      const index = this.friends.indexOf(item.name);
      if (index >= 0) this.friends.splice(index, 1);
    },
    downloadPSD() {
      const a = document.createElement("a");
      a.href = self.expoCategoryPSDPath;
      a.download = self.expoCategoryPSDPath.split("/").pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    UploadExpoResource(input, fieldName, fieldsrc) {
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };

        // const validImageTypes = ["image/jpeg", "image/png"];
        // if (!validImageTypes.includes(bgImgfile.type)) {
        //   alert("Only gif,jpeg & png file allowed.");
        //   return false;
        // }

        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 10) {
          alert("Uploaded file size exceeds 10 MB");
          return false;
        }

        const reader = new FileReader();
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        var uploadTargetPath =
          obj.eventcollectionname + "/Exhibitor/Resources/";

        reader.onload = (e) => {
          let fileBlob = e.target.result;
          console.log("bgImgfile>>>>", bgImgfile);
          console.log("fieldName>>>>", fieldName);
          console.log("fieldsrc>>>>", fieldsrc);
          console.log("metadata>>>>", metadata);
          console.log("e>>>>", e);
          self.uploadServerImage(fileBlob, uploadTargetPath, file, "Resource");

          //vm.uploadFile(bgImgfile, fieldName, fieldsrc);
          //this[fieldsrc] = e.target.result;
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    add_expo_link() {
      if (this.exhibitorResourceTitle && this.exhibitorResourceLink) {
        this.ResourcesLink.push({
          Id: this.ResourcesLink.length + 1,
          Title: this.exhibitorResourceTitle,
          Link: this.exhibitorResourceLink,
        });
        this.exhibitorResourceTitle = null;
        this.exhibitorResourceLink = null;
      }
    },
    UploadImage(input, fieldName, fieldsrc) {
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 1) {
          alert("Uploaded file size exceeds 1 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        var uploadTargetPath = obj.eventcollectionname + "/Exhibitor/Booth/";

        reader.onload = (e) => {
          let fileBlob = e.target.result;
          console.log("bgImgfile>>>>", bgImgfile);
          console.log("fieldName>>>>", fieldName);
          console.log("fieldsrc>>>>", fieldsrc);
          console.log("metadata>>>>", metadata);
          console.log("e>>>>", e);
          self.uploadServerImage(fileBlob, uploadTargetPath, file, "Image");

          //vm.uploadFile(bgImgfile, fieldName, fieldsrc);
          //this[fieldsrc] = e.target.result;
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    sendToExpoPreview() {
      if (self.expoId && self.expoName) {
        store.commit("addExhibitorID", self.expoId);
        var url =
          "/exhibitorsview/" +
          self.expoId +
          "/" +
          self.expoName.replace(/%20/g, "_");
        router.push(url.replace(/ /g, "_"));
      } else {
        router.push("/exhibitorshall");
      }
    },
    sendToDefaultLanding() {
      if (self.$store.getters.getDefaultLandingPage) {
        router.push({ name: self.$store.getters.getDefaultLandingPage });
      }
    },
    //show map contact
    // update_logo(input, fileWH, uploadedField) {
    //   // You can update avatar Here
    //   if (input) {
    //     let file = input;
    //     let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
    //     if (!validImageTypes.includes(file.type)) {
    //       alert("Only gif,jpeg & png file allowed.");
    //       return false;
    //     }
    //     let dimension = fileWH.split("x");
    //     let uploadTargetPath = `${vm.getEventCollectionName()}/Session/LogoImage/`;
    //     var _URL = window.URL || window.webkitURL;
    //     let img = new Image();
    //     var objectUrl = _URL.createObjectURL(file);
    //     img.onload = function () {
    //       //if (this.width >= dimension[0] && this.height >= dimension[1]) {
    //       const reader = new FileReader();
    //       reader.onload = (e) => {
    //         let fileBlob = e.target.result;
    //         //vm.$refs.regV3.EventsData[0].EventLogo = fileBlob;
    //         self.uploadServerImage(
    //           fileBlob,
    //           uploadTargetPath,
    //           file,
    //           uploadedField
    //         );
    //       };
    //       reader.readAsDataURL(file);

    //       // } else {
    //       //   alert("Please upload a banner " + fileWH + " px");
    //       //   return false;
    //       // }
    //       _URL.revokeObjectURL(objectUrl);
    //     };
    //     img.src = objectUrl;
    //   }
    // },

    uploadServerImage(fileBlob, target, file, type) {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.getClientId(),
          eventId: self.getEventId(),
        },
        files: [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ],
      };
      axios
        .post(APIs.UploadFiles, requestData, { headers: headers })
        .then(function (res) {
          console.log("res>>>>",res);
           console.log("type>>>>",type);
           debugger;

          if (res.data.status == 0) {
            if (type == "Image") {
              if (res.data.data[0].value.url) {
                self.expoHotspotImg = res.data.data[0].value.url;
                self.previewCategoryImage = res.data.data[0].value.url;
              }
            } else {
              if (res.data.data[0].value.url) {
    
                self.Resources.push(res.data.data[0].value.url);

                var filePath = res.data.data[0].value.url.replace("%2F", "/");
                var arr = filePath.split("/");
                var arr2 = arr[arr.length - 1]
                  .replace(/%20/g, " ")
                  .replace(/%26/g, "")
                  .replace(".pdf", "")
                  .replace(".xlsx", "")
                  .replace(".pptx", "")
                  .replace(".docx", "")
                  .replace(".mp4", "")
                  .split("?");

                self.ResourcesForView.push({
                  Filename: arr2[0],
                  Url: res.data.data[0].value.url,
                });
              }
            }
          }

          bus.$emit("toggleLoader", false);
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
        });
    },
    AddExpoBoothPopup(step) {
      this.e6 = step;
      this.ExpoBoothAdd = true;
    },
    FetchAttendees() {
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
        //"x-api-key": APIs.DeleteAttendeeApiKey,
      };
      let requestData = {};
      requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          search: [],
          filter: [],
          sort: { sortBy: "FirstName", sortOrder: "asc" },
          pagination: {
            Page: 1,
            PageSize: 2000,
          },
          origin: "COMPACT",
        },
      };

      axios
        .post(APIs.AttendeeSearch, requestData, { headers: headers })
        .then((response) => {
          this.mappedContactsList = response.data.result;
        });
    },
    /****/

    FetchCategoryList() {
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + this.getSessionToken(),
        instanceId: "OA_UAT",
        clientId: this.$store.state.client[0].id,
        eventId: this.$store.state.eventid,
      };

      axios
        .get(APIs.AddExpoCategoryList, { headers: headers })
        .then((response) => {
          var data = response.data.results;
          for (var i = 0; i < data.length; i++) {
            if (data[i].ImagePath != "" && data[i].PSDPath) {
              this.ExpoCategoryList.push(data[i]);
              if (data[i].ClientsDefault) {
                if (data[i].ClientsDefault[0] == self.getClientId()) {
                  self.isDefaultTemplateSelected = true;
                  self.expoCategory = data[i];
                  self.onCategoryUpdate(data[i]);
                }
              }
            }
          }

          this.ExpoCategoryList.sort((a, b) => a.Name.localeCompare(b.Name));
        });
    },
    onCategoryUpdate(categorydetails) {
      self.previewCategoryImage = categorydetails.DefaultImagePath
        ? categorydetails.DefaultImagePath
        : categorydetails.ImagePath;
      self.expoHotspotImg = self.previewCategoryImage;
      self.expoCategoryPSDPath = categorydetails.PSDPath;
      self.additionalHtml = categorydetails.AdditionalHtml
        ? categorydetails.AdditionalHtml
        : "";
    },
    expoFormSubmit() {
      if (
        (self.mappedContactsList && self.mappedContactsList.length > 0) ||
        (self.mappedContactsAdminList && self.mappedContactsAdminList.length > 0)
      ) {
        self.expoMappedContact = mergeArrays(
          self.mappedContactsList,
          self.mappedContactsAdminList
        );
      }
      if (self.expoMappedContact && self.expoMappedContact.length > 0) {
        self.expoMappedContact.map((user) => {
          if (self.selectedboothAdmin.includes(user.AttendeeId)) {
            user.IsAdmin = true;
          }
        });
      }
      console.log("mapppppeedd=====", self.expoMappedContact);

      bus.$emit("toggleLoader", true);
      if (!self.expoName) {
        self.showSnackbar("Exhibitor Name is mandatory", "error", "top");
        bus.$emit("toggleLoader", false);
        return;
      } else {
        //click function
        var Exhibitors = {};
        if (self.additionalHtml) {
          var addHtml = self.additionalHtml;
          addHtml = addHtml.replace("{{boothlogo}}", this.expoLogo);
          self.additionalHtml = addHtml;
          this.expoCategory.HtmlCode =
            this.expoCategory.HtmlCode + self.additionalHtml;
        }

        if (self.podiumTitle) {
          Exhibitors = {
            Name: this.expoName,
            Phone: this.expoPhoneNo,
            BoothNo: this.expoBoothNo,
            Email: this.expoEmail,
            Website: this.expoWebsite,
            Category: "",
            MappedContacts: this.expoMappedContact,
            Profile: this.expoProfile,
            ShowcaseVideoURL: this.expoShowcaseVideo,
            HotspotImageURL: this.expoHotspotImg,
            HtmlCode: this.expoCategory.HtmlCode,
            Logo: this.expoLogo,
            IsPublished: true,
            DisplaySequence: "",
            AriealBoothImgURL: "",
            Resources: this.Resources && this.Resources.length > 0 ? this.Resources : "",
            ResourcesLink:
              this.ResourcesLink && this.ResourcesLink.length > 0 ? this.ResourcesLink : "",
            ShowcaseImages: "",
            TemplateName: this.expoCategory.Name,
            UserRoles: [
              {
                RoleID: 10,
                RoleName: "AppUser",
              },
              {
                RoleID: 12,
                RoleName: "Exhibitor",
              },
            ],
            SocialLinks: [
              { Facebook: this.expoFacebook },
              { Twitter: this.expoTwitter },
              { GooglePlus: this.expoinstagram },
              { LinkedIn: this.expoLinkdin },
            ],
            mappedchatgroup: "",
            RoundTableTopic: "",
            Type: "",
            PodiumDetails: {
              Title: this.podiumTitle,

              Description:this.podiumDescription? this.podiumDescription.slice(0, 290):'',
              CTALink: this.ctaLink,
              KnowMoreLink: this.knowMoreLink,
            },
          };
        } else {
          Exhibitors = {
            Name: this.expoName,
            Phone: this.expoPhoneNo,
            BoothNo: this.expoBoothNo,
            Email: this.expoEmail,
            Website: this.expoWebsite,
            Category: "",
            MappedContacts: this.expoMappedContact,
            Profile: this.expoProfile,
            ShowcaseVideoURL: this.expoShowcaseVideo,
            HotspotImageURL: this.expoHotspotImg,
            HtmlCode: this.expoCategory.HtmlCode,
            Logo: this.expoLogo,
            IsPublished: true,
            DisplaySequence: "",
            AriealBoothImgURL: "",
            Resources: this.Resources && this.Resources.length > 0 ? this.Resources : "",
            ResourcesLink:
              this.ResourcesLink && this.ResourcesLink.length > 0 ? this.ResourcesLink : "",
            ShowcaseImages: "",
            TemplateName: this.expoCategory.Name,
            UserRoles: [
              {
                RoleID: 10,
                RoleName: "AppUser",
              },
              {
                RoleID: 12,
                RoleName: "Exhibitor",
              },
            ],
            SocialLinks: [
              { Facebook: this.expoFacebook },
              { Twitter: this.expoTwitter },
              { GooglePlus: this.expoinstagram },
              { LinkedIn: this.expoLinkdin },
            ],
            mappedchatgroup: "",
            RoundTableTopic: "",
            Type: "",
          };
        }

        let headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getSessionToken(),
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
          //"x-api-key": APIs.DeleteAttendeeApiKey,
        };
        var requestData = {};

        if (self.expoId) {
          requestData = {
            data: Exhibitors,
            key: {
              id: self.expoId,
            },
          };
          axios
            .put(APIs.ExpoAddDataApi, requestData, { headers: headers })
            .then(function (response) {
              console.log("Data", self.expoMappedContact);
              if (response.status == 200) {
                bus.$emit("toggleLoader", false);
                self.e6 += 1;

                if (self.e6 == 7) {
                  self.ExpoBoothAdd = false;
                  self.showSnackbar(
                    "Exhibitor Updated Successfully",
                    "success",
                    "top"
                  );
                  if(self.expoId){
 self.sendToExpoPreview();
                  }
                 
                  if (
                    self.previousMappedContactsCount !=
                    self.expoMappedContact.length
                  ) {
                    self.sendBulkAdminInviteMail();
                    self.sendBulkRepInviteMail();
                  }
                } else {
                  self.ExpoBoothAdd = true;
                }
              }
            })
            .catch(function (error) {
              console.log("Error adding attendee:", error);
              //reject(error);
            });
          // .finally(() => {
          //   self.sendBulkInviteMail();
          // });
        } else {
          console.log("Exponame", self.expoName);
          requestData = {
            data: Exhibitors,
          };
          axios
            .post(APIs.ExpoAddDataApi, requestData, { headers: headers })
            .then(function (response) {
              self.expoId = response.data.ExhibitorId;
              console.log("response====", response.data.ExhibitorId);
              if (response.status == 200) {
                bus.$emit("toggleLoader", false);
                self.showSnackbar(
                  "Exhibitor Added Successfully",
                  "success",
                  "top"
                );
                self.e6 += 1;
              }
            })
            .catch(function (error) {
              console.log("Error adding attendee:", error);
              //reject(error);
            });
        }
      }
      console.log("step", self.e6);
    },
    uploadedImagePath(data) {
      if (data && data.Status == 200) {
        self.cropImageUrl = null;
        self.imageFileDetails = null;
        self.folderImageUploadPath = null;
        self.expoLogo = data.Path;
      } else {
        alert("fail");
      }
    },
    //cropper
    update_exhibitorLogo(input) {
      debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      bus.$emit("toggleLoader", true);
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        var metadata = {
          contentType: file.type,
        };

        console.log(metadata);
        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          bus.$emit("toggleLoader", false);
          return false;
        }
        // let dimension = fileWH.split("x");

        // console.log(dimension);
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;
            self.resetCropper += 1;
            self.cropImageUrl = null;
            self.cropImageUrl = e.target.result;
            self.imageFileDetails = file;
            self.folderImageUploadPath =
              obj.eventcollectionname + "/Exhibitor/Logo/";
            bus.$emit("toggleLoader", false);
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    expoFormBackStep() {
      this.e6 -= 1;
    },
    //edit expo popup
    openEditExpoPopup() {
      this.e6 = 1;
      this.ExpoBoothAdd = true;
      this.toogleExpoHeadding = true;
    },
    fetchExhibiorDetailsbyID(exhibitorid) {
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + this.getSessionToken(),
        instanceId: "OA_UAT",
        clientId: this.$store.state.client[0].id,
        eventId: this.$store.state.eventid,
      };
      axios
        .get(APIs.FetchExpoDetailsbyID + "?expoId=" + exhibitorid, {
          headers: headers,
        })
        .then((response) => {
          console.log("response2====", response);
          //this.allExhibitorsList=response.data.results
          if (response.data.status == 0) {
            bus.$emit("toggleLoader", false);
            var expodetails = response.data.result;
            self.expoHotspotImg = expodetails.HotspotImageURL;
            self.expoName = expodetails.Name;
            self.expoPhoneNo = expodetails.Phone;
            self.expoWebsite = expodetails.Website;
            self.expoBoothNo = expodetails.Website;
            self.expoEmail = expodetails.Email;
            // self.expoCategory = expodetails.TemplateName
            //   ? expodetails.TemplateName
            //   : expodetails.Category;
            self.expoShowcaseVideo = expodetails.ShowcaseVideoURL;
            self.expoId = expodetails.ExhibitorId;

            self.expoProfile = expodetails.Profile;
            self.expoLogo = expodetails.Logo;
            self.previewCategoryImage = self.expoHotspotImg;

          console.log("expodetails====",expodetails);

            if (expodetails.MappedContacts && expodetails.MappedContacts.length > 0) {
              self.previousMappedContactsCount =
                expodetails.MappedContacts.length;
              expodetails.MappedContacts.map((user) => {
                self.expoMappedContact.push(user);
              });
            }

            for (var i = 0; i < expodetails.SocialLinks.length; i++) {
              if (expodetails.SocialLinks[i]["Facebook"] != undefined) {
                this.expoFacebook = expodetails.SocialLinks[i]["Facebook"];
              } else if (expodetails.SocialLinks[i]["Twitter"] != undefined) {
                this.expoTwitter = expodetails.SocialLinks[i]["Twitter"];
              } else if (expodetails.SocialLinks[i]["LinkedIn"] != undefined) {
                this.expoLinkdin = expodetails.SocialLinks[i]["LinkedIn"];
              }
              else if (expodetails.SocialLinks[i]["GooglePlus"] != undefined) {
                this.expoinstagram = expodetails.SocialLinks[i]["GooglePlus"];
              }
              console.log(
                "SocialLinks LinkedIn",
                expodetails.SocialLinks[i]["LinkedIn"]
              );
            }

            for (let i = 0; i < expodetails.Resources.length; i++) {
              var filePath = expodetails.Resources[i].replace("%2F", "/");
              var arr = filePath.split("/");
              console.log("arr====", arr);
              var arr2 = arr[arr.length - 1]
                .replace(/%20/g, " ")
                .replace(/%26/g, "")
                .replace(".pdf", "")
                .replace(".xlsx", "")
                .replace(".pptx", "")
                .replace(".docx", "")
                .replace(".mp4", "")
                .split("?");

              console.log("arr2====", arr2);

              self.ResourcesForView.push({
                Filename: arr2[0],
                Url: expodetails.Resources[i],
              });
            }

            self.Resources = expodetails.Resources;
             if(self.Resources == ''){
                  self.Resources = [];
                }
            self.ResourcesLink = expodetails.ResourcesLink;
            if (expodetails.PodiumDetails) {
              this.podiumTitle = expodetails.PodiumDetails.Title;
              this.podiumDescription = expodetails.PodiumDetails.Description;
              this.ctaLink = expodetails.PodiumDetails.CTALink
                ? expodetails.PodiumDetails.CTALink
                : null;
              this.knowMoreLink = expodetails.PodiumDetails.KnowMoreLink;
            }

            var repersentatives;
            if (self.expoMappedContact && self.expoMappedContact.length > 0) {
              self.expoMappedContact.map((user) => {
                if (user.IsAdmin) {
                  repersentatives = {
                    AttendeeId: user.AttendeeId,
                    Company: user.Company,
                    Designation: user.Designation,
                    Email: user.Email,
                    FirstName: user.FirstName,
                    LastName: user.LastName,
                    ProfilePictureURL: user.ProfilePictureURL,
                    Name: user.Name,
                    IsAdmin: true,
                  };
                  this.selectedboothAdmin.push(user.AttendeeId);
                  this.mappedContactsAdminList.push(repersentatives);
                  this.mappedContactsList.push(repersentatives);
                  this.selectedboothReps.push(user.AttendeeId);
                } else {
                  repersentatives = {
                    AttendeeId: user.AttendeeId,
                    Company: user.Company,
                    Designation: user.Designation,
                    Email: user.Email,
                    FirstName: user.FirstName,
                    LastName: user.LastName,
                    ProfilePictureURL: user.ProfilePictureURL,
                    Name: user.Name,
                  };
                  this.mappedContactsList.push(repersentatives);
                  this.selectedboothReps.push(user.AttendeeId);
                }
              });
            }
          }
        });
      this.FetchCategoryList();

      console.log(exhibitorid);
    },
  },
};
</script>
<style lang="scss">
.expo-studio-container {
  background: url(../assets/Images/dark-expo-back.png) no-repeat scroll center
    center / cover;
}
.disable-drop .v-input .v-input__control .v-input__slot {
    opacity: 0.3;
    cursor: not-allowed;
}
</style>